var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":_vm.titulo,"titleIcon":_vm.icone}},[_c('acesso')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }